import React, { useState, useEffect, useCallback } from "react";
import Layout from "../../Shared/Layout";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../../_services/apiUrl";
import { post } from "../../../_services/apiService";
import toast from "react-hot-toast";
import ImageSection from "./ImageSection";
import { decryptData } from "../../../_services/encDnc";
import './productdetail.css';
import DetailsOfProduct from "./DetailsofProduct";
import CustomerReviews from "./CustomerReviews";
import { Toaster } from "react-hot-toast";
import { useWishlist } from "../../../context/wishlistContext";

const ProductDetail = () => {
    const { guestIdInt, ipAddress, isLoggedIn, setIsLoggedIn } = useWishlist();
    const { slug } = useParams();
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState(null);

    const navigate = useNavigate();


    useEffect(() => {
        if (!slug || !guestIdInt || ipAddress === "") return;

        const fetchDetails = async () => {
            try {
                setLoading(true);
                const payload = {
                    slug,
                    guest_id: guestIdInt,
                    ip_address: ipAddress,
                };
                const res = await post(API_URL.productBySlug, payload);
                const product = res?.data || res;
                setDetails(product);
            } catch (err) {
                setDetails(null);
            } finally {
                setLoading(false);
            }
        };

        fetchDetails();
    }, [slug, guestIdInt, ipAddress]);

    const [submitted, setSubmitted] = useState(false);
    const [reviewLoading, setReviewLoading] = useState(false);

    const [ratingForm, setRatingForm] = useState({
        product_id: null,
        comment: "",
        rating: 0,
        images: [],
        imagePreviews: [],
    });
    useEffect(() => {
        setRatingForm((prev) => ({
            ...prev,
            product_id: details?.id || null,
        }));
    }, [details]);


    const handleRating = (rate) => {
        setRatingForm((prev) => ({
            ...prev,
            rating: rate,
        }));
    };

    const handleCommentChange = (e) => {
        setRatingForm((prev) => ({
            ...prev,
            comment: e.target.value,
        }));
    };

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files || []);

        if (!files.length) return;

        const validFiles = files.filter((file) => file.type.startsWith("image/"));

        if (!validFiles.length) {
            toast.error("Please select valid image files");
            return;
        }

        const previewUrls = validFiles.map((file) => URL.createObjectURL(file));

        setRatingForm((prev) => ({
            ...prev,
            images: [...prev.images, ...validFiles],
            imagePreviews: [...prev.imagePreviews, ...previewUrls],
        }));

        e.target.value = "";
    };

    const removeSelectedImage = (index) => {
        setRatingForm((prev) => {
            const updatedImages = [...prev.images];
            const updatedPreviews = [...prev.imagePreviews];

            if (updatedPreviews[index]) {
                URL.revokeObjectURL(updatedPreviews[index]);
            }

            updatedImages.splice(index, 1);
            updatedPreviews.splice(index, 1);

            return {
                ...prev,
                images: updatedImages,
                imagePreviews: updatedPreviews,
            };
        });
    };


    const saveRatingData = async (e) => {
        e.preventDefault();


        // ✅ LOGIN CHECK
        if (!isLoggedIn) {
            localStorage.setItem("redirectAfterLogin", window.location.pathname);

            navigate("/login");

            return;
        }

        if (!ratingForm.comment.trim() || !ratingForm.rating) {
            toast.error("Please enter review and rating");
            return;
        }

        setReviewLoading(true);
        setSubmitted(false);

        try {
            const reviewPayload = new FormData();
            reviewPayload.append("product_id", details?.id || "");
            reviewPayload.append("comment", ratingForm.comment);
            reviewPayload.append("rating", ratingForm.rating);

            ratingForm.images.forEach((file) => {
                reviewPayload.append("fileUpload[]", file);
            });

            const res = await post(API_URL.saveReviews, reviewPayload);

            // if (res?.status === 1 || res?.status === 200) {
                setSubmitted(true);

                ratingForm.imagePreviews.forEach((url) => URL.revokeObjectURL(url));

                setRatingForm({
                    product_id: details?.id || null,
                    comment: "",
                    rating: 0,
                    images: [],
                    imagePreviews: [],
                });

                const productRes = await post(API_URL.productBySlug, {
                    slug,
                    guest_id: guestIdInt,
                    ip_address: ipAddress,
                });

                const updatedProduct = productRes?.data || productRes;
                if (updatedProduct && !Array.isArray(updatedProduct)) {
                    setDetails(updatedProduct);
                }

                toast.success(res?.message || "Review submitted successfully");
            // } else {
            //     toast.error(res?.message || "Failed to submit review");
            // }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setReviewLoading(false);
        }
    };



    return (
        <Layout
            pageTitle={details?.name || "Product Detail"}
            breadcrumbLabel={details?.name || "Product Detail"}
        >
            <Toaster position="top-right" />
            <section className="same_space">
                <div className="container">
                    <div className="row">
                        <ImageSection productDataById={details} />
                        <DetailsOfProduct
                            productDataById={details}

                        />
                    </div>
                    <div>
                        <CustomerReviews
                            productDataById={details}
                            ratingForm={ratingForm}
                            setRatingForm={setRatingForm}
                            saveRatingData={saveRatingData}
                            handleRating={handleRating}
                            handleCommentChange={handleCommentChange}
                            handleImageChange={handleImageChange}
                            removeSelectedImage={removeSelectedImage}
                            reviewLoading={reviewLoading}
                            submitted={submitted}
                        />
                        
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default ProductDetail;
